import {
  clearOldWaitlistCookies,
  setWaitlistCookie,
} from 'components/business/walkin-waitlist/WalkinWaitlistCookies';
import { core, payloadToJSON, safeToNumber } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';
import _ from 'lodash';

export interface WaitlistEntry {
  businessId: number;
  partyId: number;
  serviceDate: string;
  expired?: boolean;
}

export interface WalkinWaitlistState {
  entries: {
    [businessId: number]: WaitlistEntry;
  };
  businessIdsOfEntriesExpiredSinceLastReload: number[];
}

export const initialState: WalkinWaitlistState = {
  entries: {},
  businessIdsOfEntriesExpiredSinceLastReload: [],
};

export default function reducer(state = initialState, action: BaseTockAction): WalkinWaitlistState {
  const { type, payload } = action;

  switch (type) {
    case AppConstants.WALK_IN_WAITLIST_PARTY_DETAIL_DONE:
    case AppConstants.WALK_IN_WAITLIST_ADD_DONE: {
      const res = payloadToJSON<core.WalkinWaitlistPartyDetail>(payload);
      const newState = {
        ...state,
        entries: {
          ...state.entries,
          [safeToNumber(res.businessId)]: {
            businessId: res.businessId,
            partyId: res.partyId,
            serviceDate: res.serviceDate,
          },
        },
      };

      setWaitlistCookie(newState.entries);
      return {
        ...newState,
      };
    }
    case AppConstants.WALK_IN_WAITLIST_RESTORE: {
      // This maintains behavior through the switch to using local storage
      const waitlistData =
        Object.keys(state).length === 0 ? clearOldWaitlistCookies() : state.entries;
      return {
        ...state,
        entries: {
          ...waitlistData,
        },
        businessIdsOfEntriesExpiredSinceLastReload: [],
      };
    }
    case AppConstants.WALK_IN_WAITLIST_PARTY_STATUS_DONE:
    case AppConstants.WALK_IN_WAITLIST_CANCEL_DONE: {
      const currParty = payloadToJSON<core.WalkinWaitlistPartyStatus>(payload);

      if (currParty.isWaiting) {
        return { ...state };
      }

      const expiredParty = _.find(state.entries, (entry) => entry.partyId === currParty.partyId);
      const newWaitlist = _.pickBy(state.entries, (value) => value.partyId !== currParty.partyId);

      const businessIdsOfEntriesExpiredSinceLastReload = expiredParty?.businessId
        ? [...state.businessIdsOfEntriesExpiredSinceLastReload, expiredParty.businessId]
        : [...state.businessIdsOfEntriesExpiredSinceLastReload];

      const newState = {
        ...state,
        entries: {
          ...newWaitlist,
        },
        businessIdsOfEntriesExpiredSinceLastReload,
      };

      setWaitlistCookie(newState.entries);
      return newState;
    }
    default:
      return state;
  }
}
